<template>
  <div style="width: 98%; margin: 0 auto;position: relative;">
    <div
      style="width: 100%;background: rgba(10,22,55,0.5);position: absolute;z-index: 999;"
    >
      <i class="el-icon-back ret" @click="goBack()"></i>
      <i class="blue-border-map"></i>
      <span class="textpad">{{ this.dataTitle.njName }}作业信息</span>
      <table
        class="tableShow"
        style="width: 100%;color: #fff;font-size:14px;margin: 10px;"
      >
        <tr>
          <td>监控编号：{{ this.dataTitle.imei }}</td>
          <td>出厂编号：{{ this.dataTitle.factoryCode }}</td>
          <td>机具型号：{{ this.dataTitle.productModel }}</td>
        </tr>
        <tr>
          <td>作业时间：{{ this.dataTitle.operatTime }}</td>
          <td>作业地区：{{ this.dataTitle.workArea }}</td>
          <td>机具类型：{{ this.dataTitle.catThreeName }}</td>
        </tr>
      </table>
    </div>
    <div id="tools">
      <div class="btns">
        <ul class="speedUp" v-show="popVisible">
          <li
            v-for="(item, index) in speedList"
            :key="index"
            :class="{ speedActive: index == speedIsActive }"
            @click.stop="handlePlay('accelerate', index)"
          >
            {{ item.speedTimes }}
          </li>
        </ul>
        <dl
          :class="calendarFlag == true ? 'img-onlyRead' : ''"
          @click.stop="speedChange('slowdown')"
        >
          <dt id="moderatingBtn">
            <img src="/static/bofang/jiansu.png" />
          </dt>
          <dd>减速</dd>
        </dl>

        <dl>
          <dt
            id="pauseBtn"
            @click="handlePlay(recordOperationForPauseAndContinue)"
          >
            <img :src="continueOrStopUrl" id="starImg"/>
          </dt>
          <dd id="pauseBtns">开始</dd>
        </dl>

        <dl
          :class="calendarFlag == true ? 'img-onlyRead' : ''"
          @click.stop="speedChange('accelerate')"
        >
          <dt id="acceleratedBtn">
            <img src="/static/bofang/jiasu.png" />
          </dt>
          <dd>加速</dd>
        </dl>
      </div>
    </div>

    <div id="containers" class="Gogle-maps jobModule"></div>
  </div>
</template>

<script>
import Gmap from "../../map/js/fzTianmap.js";
import Http from "../../Serves/net-http.js";
import Api from "../../Serves/net-api.js";
import { mapState, mapActions } from "vuex";
import TalksMapDialog from "../../map/js/initMapTalks.js";

import Vue from "vue";
export default {
  name: "TRecordItem",
  props: ["dialogMapDetailValue", "collecTimeStrValue", "dialogMapDetail"],
  data() {
    return {
      center: {
        lng: 116.4,
        lat: 39.9
      },
      recordGmaps: new Gmap(),
      map: "",
      dataTitle: {
        operatTime: "", //作业时间
        runTimeDay: "", //时长
        mileageDay: "", //里程
        operatArea: "", //预计作业面积
        workArea: "", //作业区域
        imei: "", //设备编号
        startTime: "", //起始时间
        getkey: ""
      },
      startTime: "",
      dialogMapDetails: this.dialogMapDetail,
      calendarFlag: true,
      startContinue: "start",
      recordOperationForPauseAndContinue: "start",
      map: "",
      TalksMapDialog: new TalksMapDialog(),
      stopedIndex: 0,
      trackList: [],
      zanting: require("/static/bofang/zanting.png"),
      kaishi: require("/static/bofang/start.png"),
      continueOrStopUrl: require("/static/bofang/start.png"),
      tingzhi: require("/static/bofang/tingzhi.png"),
      speedList: [
        {
          speedTimes: "0.5X",
          speed: 800
        },
        {
          speedTimes: "1X",
          speed: 400
        },
        {
          speedTimes: "2X",
          speed: 200
        },
        {
          speedTimes: "3X",
          speed: 133
        }
      ],
      speedIsActive: 1,
      popVisible: false,
      showProLinesCheck: false
    };
  },
  watch: {
    handleName(newVal, oldVal) {
      if (newVal == "end") {
        this.calendarFlag = true;
        this.recordOperationForPauseAndContinue = "start";
        document.getElementById("pauseBtns").innerHTML = "开始";
        this.continueOrStopUrl = this.kaishi;
      }
    },
    showProLinesCheck(newVal, oldVal) {
      if (newVal) {
        this.mapCenter = this.TalksMapDialog.map.getCenter();
        var parmse = {
          lng: this.mapCenter.x,
          lat: this.mapCenter.y
        };
        Api.doPost(Http.gis.getCountyBorderByViewCenter, parmse, false, res => {
          this.TalksMapDialog.drawCountyLine(res.result);
        });
      } else {
        this.TalksMapDialog.countyLayer.clear();
      }
    }
  },
  computed: {
    ...mapState({
      time: state => state.time,
      handleName: state => state.kName
    })
  },
  beforeDestroy() {
    if (this.TalksMapDialog.i > 0) {
      clearInterval(this.TalksMapDialog._timer);
    }
  },
  mounted() {
    this.TalksMapDialog.sendThis(this);
    let this_ = this;
    if (!this.TalksMapDialog.map) {
      this.recordInitMap();
      this.Record();
    }
    document.addEventListener("click", function(e) {
      if (this_.popVisible === true) {
        this_.popVisible = false;
      }
    });
  },
  methods: {
    recordInitMap() {
      if (this.TalksMapDialog.map) {
        this.TalksMapDialog.map.remove()
      }
      this.TalksMapDialog.init("containers", 12);
    },
    recordClose() {
      this.$emit("dialogMapDetailFn", false);
    },
    Record() {
      let this_ = this;
      //轨迹
      this.imei = this.$store.state.todayimei;
      this.startTime = this.$store.state.time.startTime;
      var url = Http.test + "/purchaseSubsidyMonitor/findTrack";
      var parmse = {
        imei: localStorage.getItem("imei"),
        startTime: localStorage.getItem("startTime"),
        deviceType: localStorage.getItem("deviceType")
      };
      Api.doPost(
        url,
        parmse,
        false,
        res => {
          //轨迹路线
          var List = res.result.list;
          this.trackList = res.result.list;
          this.dataTitle = res.result;
          this.lineArr = List;
          if (this_.lngLatCenter) {
            this_.TalksMapDialog.map.setCenter(this_.lngLatCenter);
          } else {
            let Coordinate = {
              x: Number(List[0].lng),
              y: Number(List[0].lat)
            };
            this_.TalksMapDialog.map.setCenter(Coordinate);
          }

          this_.TalksMapDialog.drawLine(List);
        },
        function(err) {}
      );
    },
    speedChange(typeName) {
      if (this.popVisible) {
        if (typeName == "slowdown") {
          this.speedIsActive =
            this.speedIsActive == 0 ? 0 : this.speedIsActive - 1;
        } else {
          let len = this.speedList.length - 1;
          this.speedIsActive =
            this.speedIsActive == len ? len : this.speedIsActive + 1;
        }
        this.speedNum = this.speedList[this.speedIsActive].speed;
        if (this.trackList.length > 0) {
          this.TalksMapDialog.playBack(
            this.trackList,
            typeName,
            this.stopedIndex,
            this.stopedIndex > 0,
            undefined,
            this.speedNum
          );
        }
      } else {
        this.popVisible = true;
      }
    },
    handlePlay(typeName, index) {
      if (index || index === 0) {
        this.speedNum = this.speedList[index].speed;
      }
      if (document.getElementById('pauseBtns').innerHTML === '开始') {
        typeName = 'start'
      }
      if (typeName === "start") {
        //开始
        let name_ = this.$store.state.kName;
        this.$store.state.kName = name_ ? "" : "start";
        this.stopedIndex = 0;
        this.calendarFlag = false;
        this.recordOperationForPauseAndContinue = "pause";
        document.getElementById("pauseBtns").innerHTML = "停止";
        document.getElementById('starImg').src = require('../../../static/bofang/tingzhi.png')
        this.continueOrStopUrl = this.tingzhi;
        this.speedNum = 400;
        this.speedIsActive = 1;
      } else if (typeName === "pause") {
        this.stopedIndex = this.TalksMapDialog.i;
        this.recordOperationForPauseAndContinue = "continue";
        document.getElementById("pauseBtns").innerHTML = "继续";
        this.continueOrStopUrl = this.kaishi;
        this.calendarFlag = true;
        this.popVisible = false;
      } else if (typeName === "continue") {
        this.recordOperationForPauseAndContinue = "pause";
        document.getElementById("pauseBtns").innerHTML = "停止";
        this.continueOrStopUrl = this.tingzhi;
        this.calendarFlag = false;
      } else if (typeName === "stop") {
        this.TalksMapDialog.lastLinePoints = [];
        this.calendarFlag = true;
        this.popVisible = false;
      } else if (typeName === "accelerate") {
        //加速减速
        this.speedIsActive = index;
        this.speedNum = this.speedList[index].speed;
        //					this.popVisible = false;
      }

      if (this.trackList.length > 0) {
        this.TalksMapDialog.playBack(
          this.trackList,
          typeName,
          this.stopedIndex,
          this.stopedIndex > 0,
          undefined,
          this.speedNum
        );
      }
    },

    goBack() {
      this.Info.Info.imei = this.$route.params.imei;
      this.Info.Info.stat_time = this.$route.params.stat_time;
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.items p {
  height: 40px;
  line-height: 18px;
  padding-left: 10px;
  color: #fff;
}

.tableList1 {
  margin-top: 10px;
}

.ret {
  font-size: 22px;
  font-weight: bold;
  color: #75c3ff;
}

.ret:hover {
  font-size: 22px;
  font-weight: bold;
  color: #297af5;
  cursor: pointer;
}

#control {
  width: 70%;
  display: flex;
  justify-content: space-between;
}
/* .side{
    width:15%;
    height:500px;
    background-color:#08172E;
    color: #ffffff;
    float: left;
    z-index: 666;
  }
  .openspan{
    display: inline-block;
    width:30px;height:30px;
    position: relative;left:0;
    top:258px;
    z-index: 9999
  }
  .closespan{
    display: inline-block;
    width:30px;height:30px;
    position: relative;left:0;
    top:258px;
    z-index: 9999
  } */

.Gogle-maps {
  height: calc(100vh - 122px);
  width: 100%;
  margin-bottom: 15px;
  /*margin-top:10px;*/
  position: relative;
  z-index: revert;
}

.goole-block {
  height: 102px;
  width: 100%;
  background: rgba(10, 22, 55, 0.5);
  z-index: 3;
  color: #ffffff;
  padding-left: 40px;
  position: absolute;
}

.goole-block p {
  color: #ffffff;
  font-size: 16px;
  line-height: 35px;
  display: inline-block;
  font-weight: bold;
  /*margin-top: 7px;*/
  margin-left: 5px;
}

.colseGogle {
  height: calc(100vh - 107px);
  width: 100%;
  float: left;
}

.allText {
  margin: 15px;
}

.allSize {
  font-size: 18px;
}

.textpad {
  margin: 0 10px;
  font-size: 16px;
  color: #fff;
}

.details-ret {
  display: inline-block;
  margin-left: 15px;
}

.details-ret span {
  display: inline-block;
  margin-left: 5px;
  font-size: 14px;
  font-weight: unset;
  color: #f45a2b;
}

.blue-border-map {
  display: inline-block;
  width: 5px;
  height: 20px;
  position: relative;
  top: 3px;
  background-color: #297af5;
}
/* .gm-control-active, .gmnoprint{
    z-index: 4 !important;
  } */
</style>



// WEBPACK FOOTER //
// src/components/Record/TodayRecordItem.vue